import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "k-drawer-items" }
const _hoisted_2 = { class: "navigation-sidebar-item bottom-menu navigation-sidebar-item--with-submenu" }
const _hoisted_3 = ["href", "aria-label", "aria-current", "aria-disabled", "onKeyup", "onClick"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "flyout-menu-popup__content" }
const _hoisted_6 = { class: "flyout-menu-popup__content-link navigation-sidebar-item text-link" }
const _hoisted_7 = ["href"]

import { computed, ref } from 'vue';
import { Popup } from '@progress/kendo-vue-popup';
import { useRoute } from 'vue-router';
import config from '@/../service/project.config.js';
import helpers from '@/helpers';
import useTranslations from '@/composables/useTranslations';
import { useSpaceStore } from '@/stores/space.store';
import { INavigationSidebarItem } from '@/types/navigationSidebarTypes';
import { CwxBackend } from '@/types/cwxBackend';
import { animationSetting } from '@/constants/globalKendoConfig';


export default /*@__PURE__*/_defineComponent({
  __name: 'NavigationSidebarFooter',
  props: {
    subItems: {},
    expanded: { type: Boolean }
  },
  emits: ["item-click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const spaceStore = useSpaceStore();
const { translate: t } = useTranslations();
const route = useRoute();
const flyoutMenu = ref(null);
const isFlyoutMenuOpen = ref(false);

const footerItems = computed(() => {
  const bottomItems: INavigationSidebarItem[] = props.subItems.slice();

  bottomItems.forEach((item: INavigationSidebarItem) => {
    if (item.icon === 'icon-cog') item.ariaLabel = `${t('Settings')}`;
  });

  return [
    ...bottomItems,
    {
      ariaLabel:
        props.expanded === true ? `${t('Close')} ${t('Menu')}` : `${t('Common.Open')} ${t('Menu')}`,
      text: '',
      subType: 'toggle',
      icon: props.expanded === true ? 'icon-double-angle-left' : 'icon-double-angle-right',
      isOpen: false,
      selected: false,
      classes: '',
    },
  ] as INavigationSidebarItem[];
});

function isHref(item: INavigationSidebarItem) {
  return !(
    (item?.isFlyout && spaceStore.spaceDetails.type === CwxBackend.SpaceType.Challenge) ||
    !item?.url
  );
}

function onItemClick(item: INavigationSidebarItem) {
  if (item.isFlyout && spaceStore.spaceDetails.type === CwxBackend.SpaceType.Challenge) {
    isFlyoutMenuOpen.value = !isFlyoutMenuOpen.value;
  } else if (item?.url) {
    window.location.href = config.backend + item?.url;
  } else if (item?.action) {
    item.action();
  }

  emit('item-click', item);
}

function openChallengeModal() {
  isFlyoutMenuOpen.value = false;
  window.location.replace(
    `/Challenges/CreateChallenge?spaceId=${spaceStore.spaceDetails.id}&returnUrl=${route.fullPath}`,
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        ref_key: "flyoutMenu",
        ref: flyoutMenu,
        class: "navigation-sidebar-item__bottom-menu"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(footerItems.value, (bottomMenuItem, bottomMenuItemIndex) => {
          return (_openBlock(), _createElementBlock("a", {
            key: bottomMenuItemIndex,
            class: "navigation-sidebar-item",
            tabindex: "0",
            role: "button",
            href: isHref(bottomMenuItem) ? _unref(config).backend + `${bottomMenuItem.url}` : undefined,
            target: "_blank",
            "aria-label": bottomMenuItem?.ariaLabel || bottomMenuItem?.text,
            "aria-current": bottomMenuItem?.active ? 'true' : 'false',
            "aria-disabled": bottomMenuItem?.disabled,
            onKeyup: _withKeys(($event: any) => (isHref(bottomMenuItem) ? null : onItemClick(bottomMenuItem)), ["enter"]),
            onClick: ($event: any) => (isHref(bottomMenuItem) ? null : onItemClick(bottomMenuItem))
          }, [
            (bottomMenuItem?.icon)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  class: _normalizeClass(
              'cursor-pointer navigation-sidebar-item__menu--icon cwx-icon cwx-icon-before_' +
              bottomMenuItem?.icon
            )
                }, null, 2))
              : _createCommentVNode("", true),
            (bottomMenuItem.isFlyout)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  (bottomMenuItem.isFlyout)
                    ? (_openBlock(), _createBlock(_unref(Popup), {
                        key: 0,
                        anchor: 'flyoutMenu',
                        "class-name": 'flyout-menu-popup navigation-sidebar__flyout-menu',
                        class: _normalizeClass('flyout-menu-popup navigation-sidebar__flyout-menu'),
                        show: isFlyoutMenuOpen.value,
                        "anchor-align": { horizontal: 'left', vertical: 'middle' },
                        "popup-align": { horizontal: 'left', vertical: 'middle' },
                        animate: _unref(animationSetting)
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", {
                              class: "flyout-menu-popup__content-link text-link",
                              role: "button",
                              tabindex: "0",
                              onKeyup: _withKeys(openChallengeModal, ["enter"]),
                              onClick: openChallengeModal
                            }, _toDisplayString(_unref(t)('Settings')), 33),
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("a", {
                                href: 
                      _unref(helpers).url.outerUrl(
                        `/administration/spacehomesettings?spaceID=${_unref(spaceStore)?.spaceDetails?.id}`,
                      )
                    
                              }, _toDisplayString(_unref(t)('ExpertSettings')), 9, _hoisted_7)
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["show", "animate"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 40, _hoisted_3))
        }), 128))
      ], 512)
    ])
  ]))
}
}

})